import { isFuture, setHours, startOfTomorrow } from 'date-fns'

import { getIsOneTimeMessage } from 'components/SegmentSelector/segment-service'

export const SCHEDULED_FIELD_NAME = 'ScheduledDate'

const dateRegexISO = new RegExp('(\\d{4})-(\\d{2})-(\\d{2})T(\\d{2}):(\\d{2}):(\\d{2})[.-]?([\\d:]{0,5})Z?')

const isFormattedForISO = (date) => dateRegexISO.test(date)

export const isValidDate = (date) => isFormattedForISO(date) && isFuture(new Date(date))

export const defaultDateTomorrow = () => setHours(startOfTomorrow(), 12).toISOString()

export const hasValidScheduledDate = (msg) =>
  !getIsOneTimeMessage(msg.Trigger) || isValidDate(msg[SCHEDULED_FIELD_NAME])

export const getDefaultScheduledDate = (trigger) => (getIsOneTimeMessage(trigger) ? defaultDateTomorrow() : undefined)
